/**
 * OpenDocumentNavigator (TASK-640) — consumes the canvasStore pending-open slot
 * and navigates to /workbench/:docId. Mounted once inside the Router; both chat
 * transports (canvas chatStore, workbench WS hook) write the slot, so the agent
 * can open a document from anywhere. Renders nothing.
 */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useCanvasStore } from '../stores/canvasStore';
import { workbenchRoute } from '../utils/workbenchRoute';

export function OpenDocumentNavigator() {
  const navigate = useNavigate();
  const pending = useCanvasStore((s) => s.pendingOpenDocument);
  const clear = useCanvasStore((s) => s.clearPendingOpenDocument);

  useEffect(() => {
    if (!pending) return;
    clear();
    toast.info(`Opening ${pending.title ?? 'document'}…`);
    // TASK-796: carry the turn's task, so an agent-initiated open arrives with
    // the task banner and objective grounding — parity with the advisor clicking
    // an artifact card. Omitted when the turn named no task: a taskless workbench
    // is the honest state, not something to invent a value for. The rail's origin
    // transcript remains gated on TASK-788's verified binding, so `?task=` alone
    // never renders one task's conversation beside an unrelated document.
    //
    // Built by `workbenchRoute`, not by hand: TASK-785 made that the one place
    // the param is formed precisely because an opener that builds its own drifts
    // from the rest the first time the format changes.
    navigate(workbenchRoute(pending.documentId, pending.taskId));
  }, [pending, clear, navigate]);

  return null;
}

export default OpenDocumentNavigator;
